const Home = (props) => {
    return (
        <>
            Home component web builder
        </>
    )
}

export default Home;